import React, { Component } from 'react';
import classNames from 'classnames';
import Screens from './screens';

export default class Modules extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rolePermissionsArr: [],
      moduleObj: {},
      screensArr: [],
      actionsArr: [],
    };
    this.renderScreens = this.renderScreens.bind(this);
    this.onModuleClick = this.onModuleClick.bind(this);
    this.renderPermissions = this.renderPermissions.bind(this);
  }

  componentWillMount() {
    this.setState({
      rolePermissionsArr: this.props.rolePermissionsArr,
      moduleObj: this.props.modulePermissionObj,
      screensArr: this.props.screenPermissions,
      actionsArr: this.props.actionPermissions,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      rolePermissionsArr: nextProps.rolePermissionsArr,
      moduleObj: nextProps.modulePermissionObj,
      screensArr: nextProps.screenPermissions,
      actionsArr: nextProps.actionPermissions,
    });
    //console.log('expandCollapseAll: ', nextProps.expandCollapseAll);
  }

  handleExpandModuleRow = (rowid) => {
    // this.refs.child.showAlert();
    let display = this.refs['screenClass' + rowid].style.display;
    if (display === 'none') {
      this.refs['screenClass' + rowid].style.display = 'table-row';
      this.refs['moduleClass' + rowid].className = 'fa fa-minus-square';
    } else {
      this.refs['screenClass' + rowid].style.display = 'none';
      this.refs['moduleClass' + rowid].className = 'fa fa-plus-square';
    }
  };

  onModuleClick(e) {
    e.preventDefault();
    let moduleCheckedValue = this.state.moduleObj.permission ? false : true;

    // update Role permissions - for module, its screens and its actions
    this.renderPermissions(this.state.moduleObj, moduleCheckedValue);
  }

  renderPermissions(moduleObj, moduleCheckedValue) { // if module permission true

    // set permission true for all screens
    let screensArr = this.state.screensArr;
    screensArr.map((obj) => {
      if (obj.moduleId === moduleObj.moduleId) {
        obj.permission = moduleCheckedValue;
      }
      return obj;
    });

    // set permission true for all actions
    let actionsArr = this.state.actionsArr;
    actionsArr.map((obj) => {
      if (obj.moduleId === moduleObj.moduleId) {
        obj.permission = moduleCheckedValue;
      }
      return obj;
    });

    let modulePermissionsArr = this.state.rolePermissionsArr.data.modulePermissions;
    modulePermissionsArr.map((obj) => {
      if (obj.moduleId === moduleObj.moduleId) {
        obj.permission = moduleCheckedValue;
      }
      return obj;
    });

    moduleObj['permission'] = moduleCheckedValue;

    this.setState({
      moduleObj: moduleObj,
      screensArr: screensArr,
      actionsArr: actionsArr,
      rolePermissionsArr: this.state.rolePermissionsArr,
    });
    this.props.getFinalData(this.state.rolePermissionsArr);
  }

  renderScreens() {
    let screenPermissions = this.state.screensArr.filter((obj) => obj.moduleId === this.state.moduleObj.moduleId);
    return screenPermissions.map((obj, index) => {
      return (
        <Screens
          key={index}
          screenPermissionObj={obj}
          actionPermissions={this.state.actionsArr}
          rolePermissionsArr={this.state.rolePermissionsArr}
          getFinalData={this.storePermissions.bind(this)} />
      );
    });
  }

  // get final data from screen
  storePermissions(permissionData, parentModulePermissionFlag) {
    let moduleObj = this.state.moduleObj;
    let screenCount = 0;
    let screenFalseCount = 0;
    permissionData.data.screenPermissions.map((obj) => {
      if (obj.moduleId === moduleObj.moduleId) {
        screenCount = screenCount + 1;
        if (obj.permission === true) {
          screenFalseCount = screenFalseCount - 1;
          moduleObj['permission'] = true;
        }
        if (obj.permission === false) {
          screenFalseCount = screenFalseCount +1;
          if (screenFalseCount === screenCount) {
            moduleObj['permission'] = false;
          }          
        }        
      }
      return obj;
    });    
    this.setState({ moduleObj: moduleObj });
    this.props.getFinalData(permissionData);
  }

  render() {
    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
    });
    // To show module toggle icon
    let checkModuleScreen = this.state.screensArr.find(o => (o.moduleId === this.state.moduleObj.moduleId));
    return (
      <tr>
        <td colSpan="2">
          <table className={tableClass1}>
            <tbody>
              <tr className="trhead" key={this.state.moduleObj.moduleKey}>
                <td width="50%">
                  {checkModuleScreen ? 
                  <button onClick={(e) => this.handleExpandModuleRow(this.state.moduleObj.moduleId)} type="button" className="greyaddremove mr-15">
                    <i ref={'moduleClass' + this.state.moduleObj.moduleId} className="fa fa-plus-square" aria-hidden="true"></i>
                  </button>
                  : ''}
                  {this.state.moduleObj.moduleName}
                </td>
                <td width="50%">
                {this.state.moduleObj.moduleKey === 'DASHBOARD'? '' :
                  <button
                    type="button"
                    name={'MODULE_' + this.state.moduleObj.moduleId}
                    className="addnum"
                    title="Module permissions"
                    onClick={(e, value) => this.onModuleClick(e)}
                    value={this.state.moduleObj.permission}>
                    <i className={`${this.state.moduleObj.permission ? 'fa fa-check-square greenfont' : 'fa fa-minus-square redfont'}`} aria-hidden="true"></i>
                  </button>
                }
                </td>
              </tr>
              <tr className="nohover" ref={'screenClass' + this.state.moduleObj.moduleId} style={{ 'display': 'none' }}>
                <td colSpan="2">

                  {this.renderScreens()}

                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/containers/modules.js